export const KEY = 'loadLocale';
